import Header from "./components/Header";
import Hero from "./components/Hero";
import HotRank from "./components/HotRank";
import Timeline from "./components/Timeline";
import DirectionEntry from "./components/DirectionEntry";
import Checklist from "./components/Checklist";
import StatsBoard from "./components/StatsBoard";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50 font-sans">
      <Header />
      <main>
        <Hero />
        <HotRank />
        <Timeline />
        <DirectionEntry />
        <Checklist />
        <StatsBoard />
      </main>
      <Footer />
    </div>
  );
}